import React, { useState, useEffect, Fragment } from "react";
import { getAuth, verifyPasswordResetCode, confirmPasswordReset } from "firebase/auth";
import { Form, Card, Alert } from "react-bootstrap";
import { Link } from "react-router-dom";
import LayoutOne from "../layouts/LayoutOne";
import Breadcrumb from "../wrappers/breadcrumb/Breadcrumb";
import { BreadcrumbsItem } from "react-breadcrumbs-dynamic";

const ResetPasswordPage = ({ location }) => {
  const { pathname } = location;
  const auth = getAuth();
  const params = new URLSearchParams(window.location.search);
  const mode = params.get("mode");
  const oobCode = params.get("oobCode");

  const [email, setEmail] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (mode === "resetPassword" && oobCode) {
      verifyPasswordResetCode(auth, oobCode)
        .then((email) => setEmail(email))
        .catch(() => setError("連結已失效或錯誤"));
    }
  }, [auth, mode, oobCode]);

  async function handleSubmit(e) {
    e.preventDefault();
    setError("");
    setMessage("");
    setLoading(true);
    try {
      await confirmPasswordReset(auth, oobCode, newPassword);
      setMessage("密碼已重設成功！");
    } catch {
      setError("重設失敗，請再試一次。");
    }
    setLoading(false);
  }

  return (
    <Fragment>
      <BreadcrumbsItem to={process.env.PUBLIC_URL + "/"}>首頁</BreadcrumbsItem>
      <BreadcrumbsItem to={process.env.PUBLIC_URL + pathname}>重設密碼</BreadcrumbsItem>
      <LayoutOne
        headerContainerClass="container-fluid"
        headerPaddingClass="header-padding-2"
        headerTop="visible"
      >
        <Breadcrumb />
        <div className="login-register-area pt-100 pb-100">
          <div className="container">
            <div className="row">
              <div className="col-lg-7 col-md-12 ml-auto mr-auto">
                <div className="login-register-wrapper">
                  <div className="login-register-form">
                    <Card>
                      <Card.Body>
                        <h2 className="text-center mb-4">重設密碼</h2>
                        {error && <Alert variant="danger">{error}</Alert>}
                        {message && <Alert variant="success">{message}</Alert>}
                        {email && <p className="text-center">帳戶：{email}</p>}
                        <Form onSubmit={handleSubmit}>
                          <Form.Group id="newPassword">
                            <Form.Label>新密碼</Form.Label>
                            <Form.Control
                              type="password"
                              value={newPassword}
                              onChange={(e) => setNewPassword(e.target.value)}
                              required
                              autoFocus
                            />
                          </Form.Group>
                          <div className="login-button mt-3">
                            <button disabled={loading} className="w-100" type="submit">
                              確認重設{" "}
                              {loading && <i className="fa fa-spinner fa-pulse"></i>}
                            </button>
                          </div>
                        </Form>
                        <div className="w-100 text-center mt-3">
                          <Link to="/login">返回登入</Link>
                        </div>
                      </Card.Body>
                    </Card>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </LayoutOne>
    </Fragment>
  );
};

export default ResetPasswordPage;
